import { useMutation, useQuery } from "@apollo/react-hooks";
import { Button, Checkbox, Col, Row, TimePicker } from "antd";
import Title from "antd/lib/typography/Title";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import ScheduleImage from "../../../../Assets/Images/008.jpg";
import { Loader } from "../../../../Components/Loader";
import { CustIcon } from "../../../../Components/Svgs";
import {
  UPDATE_USER_LAST_SCREEN,
  UPDATE_USER_SHIFT,
} from "../../../../Graphql/mutations";
import {
  GET_LAST_SCREEN,
  GET_SHIFT_TIMINGS,
} from "../../../../Graphql/queries";

export const ShiftManagementPage = () => {
  const history = useHistory();
  const user_id = localStorage.getItem("user_id");

  const { data: lastScreenData } = useQuery(GET_LAST_SCREEN, {
    variables: { user_id },
    fetchPolicy: "cache-and-network",
  });

  const { data, loading } = useQuery(GET_SHIFT_TIMINGS, {
    variables: { user_id },
    fetchPolicy: "cache-and-network",
  });

  const [UPDATE_USER_LAST_SCREEN_MUTATION] = useMutation(
    UPDATE_USER_LAST_SCREEN
  );

  const [UPDATE_USER_SHIFT_MUTATION] = useMutation(UPDATE_USER_SHIFT);

  const [weekShift, setWeekShift] = useState([]);

  const [scheduleList, setScheduleList] = useState([
    { workingDay: "Monday", checked: false },
    { workingDay: "Tuesday", checked: false },
    { workingDay: "Wednesday", checked: false },
    { workingDay: "Thursday", checked: false },
    { workingDay: "Friday", checked: false },
    { workingDay: "Saturday", checked: false },
    { workingDay: "Sunday", checked: false },
  ]);

  useEffect(() => {
    if (
      lastScreenData &&
      lastScreenData?.userData?.last_screen !== history.location.pathname
    ) {
      UPDATE_USER_LAST_SCREEN_MUTATION({
        variables: {
          user_id,
          last_screen: history.location.pathname,
        },
      });
    }
  }, [lastScreenData]);

  const onContinue = () => {
    history.push("/");
  };

  useEffect(() => {
    if (data) {
      let workWeek = [
        { workingDay: "Monday" },
        { workingDay: "Tuesday" },
        { workingDay: "Wednesday" },
        { workingDay: "Thursday" },
        { workingDay: "Friday" },
        { workingDay: "Saturday" },
        { workingDay: "Sunday" },
      ];
      data.user_shift.forEach((singleDay) => {
        let dayIndex = workWeek.findIndex((d) => {
          return d.workingDay === singleDay.working_day;
        });
        if (dayIndex !== -1) {
          let startTime = singleDay.start_time.split(":");
          workWeek[dayIndex].startTime = moment().set({
            hours: startTime[0],
            minutes: startTime[1],
            seconds: startTime[2],
          });
          workWeek[dayIndex].checked = true;
          let endTime = singleDay.end_time.split(":");
          workWeek[dayIndex].endTime = moment().set({
            hours: endTime[0],
            minutes: endTime[1],
            seconds: endTime[2],
          });
        }
      });
      setWeekShift(workWeek);
    }
  }, [data]);

  return (
    <div className="rowSec">
      <div className="colSec onBoardingLeft">
        <img src={ScheduleImage} alt="" className="" />
      </div>
      <div className="colSec onBoardingRight">
        {loading ? (
          <Loader />
        ) : (
          <div className="shiftSchedule_blk">
            <Title level={2}>
              <CustIcon type="left-arrow" onClick={() => history.goBack()} />{" "}
              Your Shift Schedule
            </Title>
            <p className="subTitle">
              Here is your shift schedule, contact your reporting manager in
              case of any change.
            </p>
            {data?.userRoles[0]?.jobRoleDetails?.access_type !== "employee" ? (
              <div className="shitSchedule mb-4">
                <Row gutter={14} className="heading mb-1">
                  <Col span={2}></Col>
                  <Col span={6} className="fontmed txtdark">
                    Days
                  </Col>
                  <Col span={8} className="fontmed txtdark">
                    Start Time
                  </Col>
                  <Col span={8} className="fontmed txtdark">
                    End Time
                  </Col>
                </Row>
                {weekShift.map((field, index) => (
                  <Row key={index} gutter={14} className="shiftTimingList mb-2">
                    <Col span={2}>
                      <Checkbox
                        checked={field.checked}
                        // onChange={(e) =>
                        //   onCheckboxChange({
                        //     isChecked: e.target.checked,
                        //     index,
                        //     field,
                        //   })
                        // }
                      />
                    </Col>
                    <Col span={6} className="txtdark">
                      <div className={field.checked && "activeDay"}>
                        {field.workingDay}
                      </div>
                    </Col>
                    <Col span={8}>
                      <TimePicker
                        use12Hours
                        minuteStep={5}
                        value={field.startTime}
                        showSecond={false}
                        format="h:mm a"
                        suffixIcon={null}
                        // onChange={(time) =>
                        //   handleTimeChange({ field, index, time, type: "start_time" })
                        // }
                      />
                    </Col>
                    <Col span={8}>
                      <TimePicker
                        use12Hours
                        minuteStep={5}
                        value={field.endTime}
                        showSecond={false}
                        format="h:mm a"
                        suffixIcon={null}
                        // onChange={(time) =>
                        //   handleTimeChange({ field, index, time, type: "end_time" })
                        // }
                      />
                    </Col>
                  </Row>
                ))}
              </div>
            ) : (
              <div className="shiftSchedule_table mb-4">
              <table>
                <tr>
                  <th>Shift Days</th>
                  <th>Start Time</th>
                  <th></th>
                  <th>End Time</th>
                </tr>
                {weekShift.map((singleShift) => (
                  <tr>
                    <td>{singleShift.workingDay}</td>
                    <td>
                      {singleShift.startTime?.format("hh:mm A") || "Weekly off"}
                    </td>
                    <td>
                      {singleShift.startTime && singleShift.endTime && "to"}
                    </td>
                    <td>{singleShift.endTime?.format("hh:mm A")}</td>
                  </tr>
                ))}
                </table>
              </div>
            )}
            <div className="buttonSec">
              <Button
                type="primary"
                shape="round"
                size="large"
                className="mr-4"
                onClick={onContinue}
              >
                Continue
              </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
